export default __webpack_public_path__ + "static/media/horizontal_logo.11a700bc.svg";